export * from "./mapProductToCommerceEventItem";
